import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../home/redux/actions';
import { Row, Col, Icon } from 'antd';
import { Link } from 'react-router-dom';
import { url } from '../../helper/image';

export class Footer extends Component {
  static propTypes = {

  };

  render() {
    return (
      <Row className="footer">
        <Row>
          <Col className="footer-information">
            <Row className="list-information" type="flex" justify="center">
              <Col key={1} className="bloc" >
                <Link to='/others/contact'>CONTACTEZ NOUS</Link>
              </Col>
              <Col key={2}  className="bloc" >
                <a href='https://ynov-bordeaux.com/' target="_blank">YNOV BORDEAUX</a>
              </Col>
              <Col key={3} className="bloc" >
                <Link to='/others/mentions-legals'>MENTIONS LÉGALES</Link>
              </Col>
              <Col key={4} className="bloc">
                <Link to='/others/cgu'>CGU</Link>
              </Col>
              <Col key={5} className="bloc">
                <a href="https://privacy.ynov.com/" target="_blank" style={{textTransform:'uppercase'}}>données personnelles</a>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="bottom">
          <Col style={{ color: '#fff' }} xs={{ span: 12 }} md={{ span: 12 }}>
            <p>@BORDEAUX YNOV CAMPUS</p>
          </Col>
          <Col style={{ color: '#fff' }} xs={{ span: 12 }} md={{ span: 6, offset: 6 }}>
            <Row type="flex" justify="end">
              <Col key={1} xs={{ span: 7 }} sm={{ span: 4 }} md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 4 }} xl={{ span: 6 }}>
                <a href="https://www.instagram.com/ynov_bordeaux/">
                  <Icon type="instagram" />
                </a>
              </Col>
              <Col key={2} xs={{ span: 7 }} sm={{ span: 4 }} md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 4 }} xl={{ span: 6 }}>
                <a href="https://twitter.com/ynov_bordeaux/">
                  <Icon type="twitter" />
                </a>
              </Col>
              <Col key={3} xs={{ span: 7 }} sm={{ span: 4 }} md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 4 }} xl={{ span: 2 }}>
                <a href="https://www.facebook.com/YnovBordeaux/">
                  <Icon type="facebook" />
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
    );
  }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);


// WEBPACK FOOTER //
// ./src/features/others/Footer.js